var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"url-button-wrapper ml-3"},[_c('span',{staticClass:"shadow p-2",class:{active: _vm.showCopied}},[_c('translate',[_vm._v("Copied to clipboard")])],1),_c('b-button',{attrs:{"size":"sm","variant":"default"},on:{"click":_vm.copyToClipboard}},[_c('span',{staticClass:"fas fa-copy"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }